<script>
import { includes, without } from 'lodash/fp'
import Toggleable from '@/mixins/toggleable'

export default {
  name: 'FilterCheckboxList',
  mixins: [Toggleable],
  props: {
    filter: {
      type: Object,
      required: true
    },
    filterIndex: Number,
    value: {
      type: [Array, Object],
      default () {
        return []
      }
    }
  },
  data () {
    return {}
  },
  methods: {
    itemChanged (item, index, e) {
      console.log('item Changed')
      console.log('item: ', item)
      console.log('index: ', index)
      console.log('e: ', e)
      console.log('event: ', event)
      event.stopPropagation()
      event.preventDefault()

      // Setup the current value as an empty array for convenience
      const currentValue = this.value || []
      console.log('currentValue', currentValue)

      // If currentValue doesn't include the item, add it
      if (!includes(item)(currentValue)) {
        this.update([ ...currentValue, item ])
        return null
      }

      // If the selected item is currently in the array, remove it
      if (includes(item)(currentValue)) {
        this.update(without(currentValue)(item))
        return null
      }
    },
    update (newValue) {
      this.$emit('update', newValue)
    }
  },
  render (h) {
    const checkboxListItems = this.filter && this.filter.items && this.filter.items.map((item, index) => {
      return (
        <v-list-tile onClick="" inset class="filter-checkbox-list__item">
          <v-list-tile-action>
            <v-checkbox
              hideDetails
              value={item}
              inputValue={this.value}
              onChange={(e) => { this.itemChanged(item, index, e) }}
            >
            </v-checkbox>
          </v-list-tile-action>

          <v-list-tile-content
            onClick={(e) => { this.itemChanged(item, index, e) }}
          >
            <v-list-tile-title>{item}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      )
    })

    return (
      <v-list-group
        value={this.expanded}
      >
        <v-list-tile slot="activator">
          <v-list-tile-content>
            <v-list-tile-title>{this.filter.label}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        {checkboxListItems}
      </v-list-group>
    )
  }
}
</script>

<style lang="stylus">
// @import '~vuetify/src/stylus/settings/_colors.styl'

.filter-checkbox-list__item
  .v-list__tile__action
    min-width: 34px

  .v-input__slot
      margin: 0 !important

.filter-checkbox-list
  .filter-checkbox-list__header
    display: flex
    align-items: center
    user-select: none
    cursor: pointer
    padding: 8px 12px

    &:hover
      background-color: rgba(88, 88, 88, .33)

    .v-input
      margin-top: 0

  ul
    padding-left: 0
    line-height: 1.5em
    list-style-type: none
    margin-bottom: 12px

  .checkbox-list
    margin-left: 19px

    .filter-checkbox-list__item
      padding-left: 16px
      transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1)

      &:hover
        cursor: pointer
        background-color: rgba(88, 88, 88, .2)

      .v-input
        margin-top: 0

.label--light
  color: rgba(0,0,0,0.87)

</style>
